export default "__VITE_ASSET__ZPsbCmnH__"